export interface NameFields {
  firstName?: string;
  lastName?: string;
}

export function splitFullName(input: NameFields): NameFields {
  if (!input?.firstName) {
    return {};
  }

  if (input?.lastName) {
    return {
      firstName: input.firstName,
      lastName: input.lastName,
    };
  }

  const nameParts = input.firstName.trim().split(/\s+/);

  if (nameParts.length === 1) {
    return { firstName: nameParts[0] };
  }

  const firstName = nameParts.slice(0, -1).join(' ');
  const lastName = nameParts[nameParts.length - 1];

  return { firstName, lastName };
}
